document.addEventListener('DOMContentLoaded', () => {
  const categoryList = document.querySelector('.js-cat-list');
  const categoryField = document.querySelector('.js-cat-field');
  const loadMore = document.querySelector('.js-load-more');
  const pageDOM = document.querySelector('.js-paged');

  if (categoryList === null) {
    console.error('[SMG Blog] Category select don\'t found.');
    return;
  }

  const url = document.querySelector('.js-url');
  const listWrapper = document.querySelector('.js-container-columns');

  if (url === null) {
    console.error('[SMG Blog] URL can not be found.')
    return
  }

  function getPageNumber() {
    const page = Math.abs(parseInt(pageDOM.value, 10));

    if (isNaN(page)) {
      throw new Error('[SMG Blog] Malformed page number.')
    }

    return page;
  }

  function downPage() {
    if (pageDOM === null) {
      return;
    }

    let page = getPageNumber();

    if (page > 1) {
      page = page - 1;
    }

    pageDOM.value = page;
  }

  function getAjaxData() {
    const action = document.querySelector('.js-action');
    const nonce = document.getElementById('wp_our_nonce');
    const paged = document.querySelector('.js-paged');
    const post_type = document.querySelector('.js-post-type');
    const termID = categoryField.value;

    const data = new FormData();

    data.append('action', action.value || '');
    data.append('wp_our_nonce', nonce.value || '');
    data.append('cat', termID || '');
    data.append('paged', paged.value || 1);
    data.append('post_type', post_type.value || '');

    return data;
  }

  function fetchNewMembers(data, append = false) {
    fetch(url.value, {
      method: 'POST',
      body: data,
    })
    .then((response) => {
      if (response.status === 204) {
        downPage();
        loadMore.removeAttribute('disabled');

        return '';
      }

      return response.text()
    })
    .then((body) => {
      if (body === '') {
        loadMore.removeAttribute('disabled');
        return;
      }

      if (append) {
        listWrapper.innerHTML += body;
      } else {
        listWrapper.innerHTML = body;
      }

      loadMore.removeAttribute('disabled');
    })
    .catch(console.error)
  }

  function upPage() {
    if (pageDOM === null) {
      return;
    }

    let page = getPageNumber();
    page = page + 1;

    pageDOM.value = page;
  }

  function trigger(append) {
    loadMore.setAttribute('disabled', 'disabled');
    const data = getAjaxData();
    fetchNewMembers(data, append);
  }

  categoryList.addEventListener('click', (e) => {
    const categoryId = e.target.dataset.id;
    categoryField.value = categoryId;

    pageDOM.value = 1;
    trigger(false);
  })

  loadMore.addEventListener('click', () => {
    upPage();
    trigger(true);
  })
})
